<template>
<v-card min-height="10">
    <v-container v-if="widget_data" fluid class="pa-0 ma-0">
        <v-card-text>
            <div class="d-flex justify-space-between">
                <div class="d-flex align-center">
                    <v-icon large class="mr-3">table_chart</v-icon>
                    <div>
                        <div class="subheading text-uppercase">Low Availability Report</div>
                        <div class="heading grey--text">
                            {{from}}
                            <v-icon small>arrow_right_alt</v-icon>
                            {{until}}
                        </div>
                    </div>

                </div>
                <v-col cols="4">
                    <v-select v-model="limit" :items="[5, 10, 25, 50, 100]" hide-details filled label="Limit" />
                </v-col>
            </div>
        </v-card-text>
        <v-divider />
        <v-card-text>
            <v-data-table :headers="widget_headers" :items="widget_data" hide-default-footer must-sort disable-pagination>
                <template v-slot:item="props">
                    <tr>
                        <td>{{ props.index + 1 }}</td>
                        <td>{{ props.item.hotel }}</td>
                        <td>{{ props.item.city }}, {{ props.item.country }}</td>
                        <td class="text-right monospaced">{{ props.item.availability }}</td>

                    </tr>
                </template>
            </v-data-table>
        </v-card-text>
    </v-container>
    <v-container v-else fill-height class="pa-2 ma-0">
        <v-card-text>
            <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular :size="75" color="primary" indeterminate />
            </div>
        </v-card-text>
    </v-container>
</v-card>
</template>

<script>
import moment from 'moment';

export default {

    props: {
        url: String,
        from: {
            type: String,
            default: moment()
                .format("YYYY-MM-DD")
        },
        until: {
            type: String,
            default: moment()
                .add(2, 'months')
                .format("YYYY-MM-DD")
        },
    },

    watch: {
        from: function () {
            this.getWidget();
        },
        until: function () {
            this.getWidget();
        },
        limit: function () {
            this.getWidget();
        }
    },

    methods: {
        getWidget() {
            this.widget_data = null;
            this.$axios
                .get(this.url + "/hotel-availability-report", {
                    params: {
                        from: this.from,
                        until: this.until,
                        limit: this.limit
                    }
                })
                .then(response => {
                    this.widget_data = response.data;
                });
        }
    },

    created() {
        this.getWidget();
    },

    data() {
        return {
            widget_data: null,
            limit: 5,
            widget_headers: [
                {
                    text: '#',
                    sortable: false
                },
                {
                    text: 'Hotel',
                    sortable: false
                },
                {
                    text: 'Locality',
                    sortable: false
                },
                {
                    text: 'Availability',
                    align: 'right',
                    value: 'availability'
                },
                ],
            pagination: {
                sortBy: 'availability',
                descending: false,
                rowsPerPage: -1
            },
        }
    }
}
</script>


<style>
.monospaced {
    font-family: 'Roboto Mono', monospace;
}
</style>
